import axios from 'axios';

export default {
    overview(data) {
        return axios
            .post(process.env.VUE_APP_API_BASE_URL + 'domain/overview', data)
            .then(response => response.data);
    }
};